import { useEffect } from 'react';

type Inertable = HTMLElement & { inert: boolean };

/**
 * Marks the application root `inert` while an overlay portaled to <body> is
 * open, so screen-reader virtual cursors and pointer events cannot reach the
 * page behind it. Set imperatively rather than as a JSX prop: React 18 warns
 * on `inert={true}` and serialises it as the string "true".
 *
 * Safari < 15.5 ignores `inert`; the focus trap still covers the keyboard.
 */
export default function useInert(active: boolean, selector = '#root'): void {
  useEffect(() => {
    if (!active || typeof document === 'undefined') return undefined;
    const root = document.querySelector<HTMLElement>(selector) as Inertable | null;
    if (!root) return undefined;
    const previous = root.inert;
    root.inert = true;
    return () => {
      root.inert = previous;
    };
  }, [active, selector]);
}
